import React from "react";
import "./book-page.m.css";

export default function SectionTitle({
  title,
  width = "20%",
  titleColor = "#000",
}) {
  return (
    <div styleName="section-title">
      <div
        styleName="section-title-text"
        style={{ color: titleColor }}
      >
        {title}
      </div>

      <div
        styleName="section-title-line"
        style={{ width }}
      />
    </div>
  );
}